module.exports = __webpack_public_path__ + "img/fla-logo.fea313e0.jpg";